// src/components/steps/PlanosInfoStep.js
import React, { useState, useEffect } from 'react';
import PlanCard from '../PlanCard';
import PlanoSelectedDetailsStep from './PlanoSelectedDetailsStep';
import SuccessPage from '../steps/SuccessPage';
import { fetchPlansNearby } from '../../services/api';

const PlanosInfoStep = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const cep = localStorage.getItem('cep') || '35798600';
    fetchPlanos(cep);
  }, []);

  async function fetchPlanos(cep) {
    try {
      const data = await fetchPlansNearby(cep);
      if (Array.isArray(data) && data.length === 0) {
        setError('Nenhum plano encontrado para o CEP fornecido.');
        setPlans([]);
      } else if (data.message) {
        setError('Desculpe-nos, não encontramos Planos apropriados para o seu caso.');
        setPlans([]);
      } else {
        setPlans(data);
        setError(null);
      }
    } catch (err) {
      console.error('Erro ao buscar planos:', err);
      setError('Infelizmente não temos planos disponíveis no momento.');
      setPlans([]);
    } finally {
      setLoading(false);
    }
  }

  const handleSuccess = () => {
    setSelectedPlan(null);
    setSuccess(true);
  };

  if (loading) {
    return (
      <div className="flex justify-center mt-6">
        <div className="w-8 h-8 border-4 border-[#E5E7EB] border-t-[#2A4DD0] rounded-full animate-spin" />
      </div>
    );
  }

  if (success) {
    return <SuccessPage />;
  }

  if (selectedPlan) {
    return (
      <PlanoSelectedDetailsStep
        plano={selectedPlan}
        onBack={() => setSelectedPlan(null)}
        onSuccess={handleSuccess}
      />
    );
  }

  return (
    <div className="mt-6 w-full">
      {error ? (
        <div className="text-center flex flex-col items-center p-6 bg-gray-100 rounded-lg shadow-md">
          <p className="text-lg font-semibold text-gray-700">{error}</p>
          <p className="text-sm text-gray-500 mt-2">
            Tente novamente mais tarde ou retorne ao nosso site para mais informações.
          </p>
          <a
            href="https://alleanzabrasilcorretora.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition"
          >
            Ir para o site
          </a>
        </div>
      ) : (
        <>
          <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
            Planos disponíveis
          </h3>
          <div className="overflow-x-auto py-2">
            <div className="flex space-x-6 px-2">
              {plans.map((plano) => (
                <div key={plano.id} className="flex-shrink-0 min-w-[280px]">
                  <PlanCard
                    logoTop="/newlogo.png"
                    logoLeft="/hapivida.webp"
                    registroNumero={plano.id_operators || '---'}
                    planName={plano.plan_name}
                    itens={plano.hospitals ? plano.hospitals.map(h => h.name) : []}
                    preco={`R$${plano.plan_value}`}
                    onDetalhesClick={() => setSelectedPlan(plano)}
                    planId={plano.id}
                    onSuccess={handleSuccess}
                  />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PlanosInfoStep;
